/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOwnersByInstrumentTokens} from '../api'

 export const useQueryGetOwnersByInstrumentTokens = createReactQueryHook('getOwnersByInstrumentTokens', getOwnersByInstrumentTokens)
